/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  getV1Company,
  getV1LocationsCountries,
  getV1LocationsStates,
  getV1Role,
  getV1User,
  getV1UserDepartment,
  setBaseUrl,
  getV1UserModules
} from "../api-client/api.rbac/api";
import _ from "lodash";
import {
  getV1AssemblyItems,
  getV1Bin,
  getV1Brand,
  getV1CategoryItems,
  getV1DiscountItems,
  getV1InventoryFixedAssetItems,
  getV1InventoryItems,
  getV1StockReason,
  getV1Uom,
  getV1UomTemplates,
  getV1WarehouseLocation,
  setBaseUrl as setInventoryBaseUrl,
} from "../api-client/api.inventory/api";
import {
  getV1Assets,
  getV1AssetsAssetTypes,
  getV1AssetsJournalTypes,
  getV1BudgetBudgetMonths,
  getV1BudgetBudgetTypes,
  getV1ChartOfAccount,
  getV1CommissionPlans,
  getV1CommissionTargets,
  getV1ChartOfAccountAccountType,
  getV1Currency,
  getV1DebitNotesReasons,
  getV1ExpenseReimbursementEmployees,
  getV1ExpenseReimbursementExpenseCategories,
  getV1FiscalYear,
  getV1JournalEntries,
  getV1JournalEntriesReferenceType,
  getV1Parties,
  getV1PartiesIndustry,
  getV1PaymentTerms,
  getV1PurchaseInvoices,
  getV1PurchaseInvoicesIncoterms,
  getV1SalesInvoices,
  getV1TaxCategory,
  getV1TaxCode,
  getV1TaxTemplates,
  setBaseUrl as SetAccountingBaseUrl,
  getV1BankAccountsTypes,
  getV1Banks,
  getV1PaymentTermsDueDateTypes,
  getV1Budget,
} from "../api-client/api.accounting/api";
import { getPartyName, getToken, showSnackBar } from "./common";
import {
  setBaseUrl as setCrmBaseUrl,
  getV1CustomerSegment,
  getV1OpportunityContact,
  getV1ShippingRules,
  getV1SalesOrders,
  getV1SourceTypes,
} from "../api-client/api.sales/api";
import {
  getV1PurchaseAgreements,
  getV1PurchaseOrdersReceipts,
  getV1Rfq,
  setBaseUrl as setPurchaseBaseUrl,
} from "../api-client/api.purchase/api";
import {
  setBaseUrl as setManufacturingBaseUrl,
  getV1BillsOfMaterials,
  getV1BillsOfMaterialsListMaterials,
  getV1Equipments,
  getV1EquipmentsCategories,
  getV1Operations,
  getV1Routing,
  getV1WorkCentre,
  getV1WorkCentreCategories,
  getV1WorkOrder,
  getV1GateRegisterVehicleNumbers,
  getV1GateRegisterVehicleTypes
} from "../api-client/api.manufacturing/api";
import { getV1WorkflowReferences, setBaseUrl as setWorkflowAutomationBaseUrl } from "../api-client/api.workflow-automation/api";
import { getV1CrossHireOrders, getV1RentalAgreements, getV1RentalBillingCycles, getV1RentalTermsConditions, setBaseUrl as setRentalBaseUrl } from "../api-client/api.rental/api";
import { getV1Languages, getV1ReportsReportList, getV1Templates, setBaseUrl as setSystemFeatureBaseUrl } from "../api-client/api.system-feature/api";
import {
  getV1AccrualMaster,
  getV1AccrualType, getV1CompanyCalendar, getV1Designation, getV1DocumentMaster,
  getV1Employee, getV1EmployeeContracts, getV1Grades, getV1HireRequests, getV1JobPosts, getV1LeaveCategory, getV1LeavePolicyMaster,
  getV1LoanMaster, getV1SalaryStructureMaster, getV1Skills, getV1Teams, getV1Timezones, setBaseUrl as setHrmsBaseUrl
} from "../api-client/api.hrms/api";
import { setBaseUrl as setDriveBaseUrl } from "../api-client/api.drive/api";
import { getApiConfig, isApiConfigInitialized, onApiConfigReady } from "./api-config";
import { getV1MyAssets } from "../api-client/api.hrms/api";

import { setBaseUrl as setPmsBaseUrl, getV1Projects, getV1Tasks, getV1CostCodes, getV1CostElements } from "../api-client/api.pms/api";
import { setAiFeatureBaseUrl } from "../api-client/api.ai-feature/api";

// Initialize API base URLs using runtime configuration
// This function should be called after the API configuration has been initialized
export function initializeApiBaseUrls(): void {
  if (!isApiConfigInitialized()) {
    console.warn('API configuration not initialized yet. Base URLs will be set when configuration is available.');
    return;
  }

  const config = getApiConfig();
  const baseUrl = config.backendBaseUrl;

  setBaseUrl(`${baseUrl}/rbac`);
  setInventoryBaseUrl(`${baseUrl}/inventory`);
  SetAccountingBaseUrl(`${baseUrl}/accounting`);
  setCrmBaseUrl(`${baseUrl}/sales`);
  setHrmsBaseUrl(`${baseUrl}/hrms`);
  setSystemFeatureBaseUrl(`${baseUrl}/system-feature`);
  setDriveBaseUrl(`${baseUrl}/document`);
  setRentalBaseUrl(`${baseUrl}/rental`);
  setManufacturingBaseUrl(`${baseUrl}/manufacturing`);
  setPurchaseBaseUrl(`${baseUrl}/purchase`);
  setPmsBaseUrl(`${baseUrl}/pms`);
  setAiFeatureBaseUrl(`${baseUrl}/ai-feature`);
  // setWorkflowAutomationBaseUrl(`${baseUrl}/workflow-automation`);
}

onApiConfigReady((config) => {
  const baseUrl = config.backendBaseUrl;
  setBaseUrl(`${baseUrl}/rbac`);
  setInventoryBaseUrl(`${baseUrl}/inventory`);
  SetAccountingBaseUrl(`${baseUrl}/accounting`);
  setCrmBaseUrl(`${baseUrl}/sales`);
  setHrmsBaseUrl(`${baseUrl}/hrms`);
  setSystemFeatureBaseUrl(`${baseUrl}/system-feature`);
  setDriveBaseUrl(`${baseUrl}/document`);
  setRentalBaseUrl(`${baseUrl}/rental`);
  setManufacturingBaseUrl(`${baseUrl}/manufacturing`);
  setPurchaseBaseUrl(`${baseUrl}/purchase`);
  setPmsBaseUrl(`${baseUrl}/pms`);
  setAiFeatureBaseUrl(`${baseUrl}/ai-feature`);
  // setWorkflowAutomationBaseUrl(`${baseUrl}/workflow-automation`);
});

const createColumns = (defaultColumn: any[] = [], select: any[] = []) => {
  const columns = [...new Set([...defaultColumn, ...select])];
  if (columns.length == 0) return "";
  return `[${columns.join(",")}]`;
};
function combineFilters(
  defaultFilter: Record<string, any> | string | null | undefined,
  newFilter: Record<string, any> | null | undefined
): string {
  let updatedQuery = "";

  const baseFilters =
    defaultFilter && typeof defaultFilter === 'object'
      ? defaultFilter
      : {};
  const filters = { ...baseFilters, ...(newFilter || {}) };
  if (Object.keys(filters).length === 0) {
    return updatedQuery ? `(${updatedQuery})` : "";
  }
  Object.keys(filters).forEach(
    (key) => (updatedQuery = `${updatedQuery}${key}=${filters[key]}`)
  );
  return updatedQuery ? `(${updatedQuery})` : "";
}

export const getOptions = async (
  apiFunc: (params: any) => Promise<any>,
  filters: Record<string, any>,
  dataKey: string,
  labelKey: string,
  defaultColumn: string[],
  defaultFilter: Record<string, any> | string | null | undefined = "",
  valueKey: string = "id"
) => {
  const customeFilter = {
    ...filters,
    select: createColumns(defaultColumn, filters.select),
    filters: combineFilters(defaultFilter, filters.filters),
    order: filters?.order || `id:-1`,

  };
  const response = await apiFunc({
    ...customeFilter,
    ...getToken(),
  });

  const resolveListData = (resp: any, key: string) => {
    if (key) return resp?.data?.[key];
    if (Array.isArray(resp?.data)) return resp.data;
    if (resp?.data && typeof resp.data === 'object') {
      const values = Object.values(resp.data);
      const firstArray = values.find((v) => Array.isArray(v));
      if (Array.isArray(firstArray)) return firstArray;

      // Some endpoints return list data as an object keyed by numeric strings
      // e.g. { "0": {...}, "1": {...} }
      if (values.length && values.every((v) => v && typeof v === 'object')) {
        return values;
      }
    }
    return [];
  };

  const listData = resolveListData(response, dataKey);

  if (!dataKey && Array.isArray(listData)) {
    return (
      {
        data: listData?.map((item: Record<string, any>) => ({
          ...item,
          label:
            labelKey instanceof Function ? labelKey(item) : _.get(item, labelKey),
          value: _.get(item, valueKey),
        })) || [],
        pagination: response?.pagination
      })
  } else {
    return (
      {
        data: (Array.isArray(listData) ? listData : [])?.map((item: Record<string, any>) => ({
          ...item,
          label:
            labelKey instanceof Function ? labelKey(item) : _.get(item, labelKey),
          value: _.get(item, valueKey),
        })) || [],
        pagination: response?.pagination
      }
    );
  }
};

export const apiConfigurations = {
  company: {
    name: "companies/fetch",
    apiFunc: getV1Company,
    dataKey: "company",
    labelKey: "company_name",
    defaultColumn: ["id", "company_name"],
    defaultFilter: { "is_active.eq": 1 },
  },
  items: {
    name: "items/fetch",
    apiFunc: getV1InventoryItems,
    dataKey: "inventoryItemsList",
    labelKey: (item: Record<string, any>) => `${item.sku} - ${item.name}`,
    defaultColumn: [
      "id",
      "name",
      "unit_of_measurement",
      "default_tax_id",
      "purchase_tax_id",
      "sales_tax_id",
      "sales_price",
      "sales_description",
      "total_available_quantity",
      "total_reserved_quantity",
      "purchase_price",
      "purchase_description",
      "cost",
      "total_on_hand_quantity",
      'purchase_unit',
      'sales_unit',
      'consumption_unit',
      'stock_unit',
      'location_wise_quantity',
      "sku"
    ],
    defaultFilter: { "status.eq": 1, '&(is_variant.eq': 1, '|type.eq': 'package)' },
  },
  notPackageItems: {
    name: "items/fetch",
    apiFunc: getV1InventoryItems,
    dataKey: "inventoryItemsList",
    labelKey: (item: Record<string, any>) => `${item.sku} - ${item.name}`,
    defaultColumn: [
      "id",
      "name",
      "unit_of_measurement",
      "default_tax_id",
      "sales_price",
      "sales_description",
      "total_available_quantity",
      "total_reserved_quantity",
      "purchase_price",
      "purchase_description",
      "cost",
      "total_on_hand_quantity",
      'purchase_unit',
      'sales_unit',
      'consumption_unit',
      'stock_unit',
      "sku"
    ],
    defaultFilter: { "status.eq": 1, '&(is_variant.eq': 1, '&type.ne': 'package)' },
  },
  rentalItems: {
    name: "items/fetch",
    apiFunc: getV1InventoryFixedAssetItems,
    dataKey: "inventoryFixedAssetItems",
    labelKey: (item: Record<string, any>) => `${item.sku} - ${item.name}`,
    defaultColumn: [
      "id",
      "name",
      "unit_of_measurement",
      "default_tax_id",
      "sales_tax_id",
      "purchase_tax_id",
      "sales_price",
      "sales_description",
      "total_available_quantity",
      "total_reserved_quantity",
      "purchase_price",
      "purchase_description",
      "cost",
      "rental_replacement_cost",
      'rental_description',
      "total_on_hand_quantity",
      'purchase_unit',
      'sales_unit',
      'consumption_unit',
      'stock_unit',
      "sku"
    ],
    defaultFilter: {
      "status.eq": 1, '&is_variant.eq': 1,
      '&is_rental.eq': 1
    },
  },
  salesItems: {
    name: "items/fetch",
    apiFunc: getV1InventoryItems,
    dataKey: "inventoryItemsList",
    labelKey: (item: Record<string, any>) => `${item.sku} - ${item.name}`,
    defaultColumn: [
      "id",
      "name",
      "sku",
      "brand_data",
      "unit_of_measurement",
      "default_tax_id",
      "sales_tax_id",
      "purchase_tax_id",
      "sales_price",
      "sales_description",
      "total_available_quantity",
      "total_reserved_quantity",
      "purchase_price",
      "purchase_description",
      "cost",
      "sales_replacement_cost",
      "total_on_hand_quantity",
      'purchase_unit',
      'sales_unit',
      'consumption_unit',
      'stock_unit'
    ],
    defaultFilter: {
      "status.eq": 1, '&(is_variant.eq': 1,
      '|type.in': 'package,inventory-fixed-asset)',
      '&is_rental.eq': 0
    },
  },
  reportItems: {
    name: "items/fetch",
    apiFunc: getV1InventoryItems,
    dataKey: "inventoryItemsList",
    labelKey: (item: Record<string, any>) => `${item.sku} - ${item.name}`,
    defaultColumn: [
      "id",
      "name",
      "sku"
    ],
    defaultFilter: { '&is_variant.eq': 1 },
  },
  inventoryItems: {
    name: "inventory-items/fetch",
    apiFunc: getV1InventoryItems,
    dataKey: "inventoryItemsList",
    labelKey: (item: Record<string, any>) => `${item.sku} - ${item.name}`,
    defaultColumn: [
      "id",
      "name",
      "type",
      "unit_of_measurement",
      "default_tax_id",
      "sales_tax_id",
      "purchase_tax_id",
      "sales_price",
      "sales_description",
      "total_available_quantity",
      "total_reserved_quantity",
      "purchase_price",
      "purchase_description",
      "cost",
      "is_landed_cost",
      "total_on_hand_quantity",
      'purchase_unit',
      'sales_unit',
      'consumption_unit',
      'stock_unit',
      "sku"
    ],
    defaultFilter: { "status.eq": 1 },
  },
  fixedAssetItems: {
    name: "fixed-asset-items/fetch",
    apiFunc: getV1InventoryFixedAssetItems,
    dataKey: "inventoryItemsList",
    labelKey: (item: Record<string, any>) => `${item.sku} - ${item.name}`,
    defaultColumn: [
      "id",
      "name",
      "type",
      "unit_of_measurement",
      "default_tax_id",
      "sales_tax_id",
      "purchase_tax_id",
      "sales_price",
      "sales_description",
      "total_available_quantity",
      "total_reserved_quantity",
      "purchase_price",
      "purchase_description",
      "cost",
      "is_landed_cost",
      "total_on_hand_quantity",
      'purchase_unit',
      'sales_unit',
      'consumption_unit',
      'stock_unit',
      "sku"
    ],
    defaultFilter: { "status.eq": 1, '&type.eq': 'inventory-fixed-asset' },
  },
  currency: {
    name: "currency/fetch",
    apiFunc: getV1Currency,
    dataKey: "currencies",
    labelKey: "currency_name",
    defaultColumn: ["id", "currency_name", "symbol", 'number_format'],
    // defaultFilter: null,
    defaultFilter: { "status.eq": 1 },
  },
  salesperson: {
    name: "salesperson/fetch",
    apiFunc: getV1User,
    dataKey: "users",
    // labelKey: "first_name",
    defaultColumn: ["id", "first_name", "last_name"],
    defaultFilter: { "is_active.eq": 1 },
    labelKey: getPartyName,
  },
  users: {
    name: "users/fetch",
    apiFunc: getV1User,
    dataKey: "users",
    // labelKey: "first_name",
    defaultColumn: ["id", "first_name", "last_name"],
    defaultFilter: { "is_active.eq": 1 },
    labelKey: getPartyName,
  },
  party: {
    name: "party/fetch",
    apiFunc: getV1Parties,
    dataKey: "parties_list",
    // labelKey: getPartyName,
    labelKey: "name",
    defaultColumn: ["id", "name", "company_name", "first_name", "last_name", "type"],
    // defaultColumn:[]
    defaultFilter: { "status.eq": 1 }
  },
  department: {
    name: "department/fetch",
    apiFunc: getV1UserDepartment,
    dataKey: "department",
    labelKey: "label",
    defaultColumn: ["id", "name", "label"],
    defaultFilter: { 'status.eq': 1, '&is_draft.eq': 0 },
  },
  location: {
    name: "location/fetch",
    apiFunc: getV1WarehouseLocation,
    dataKey: "warehouseLocationList",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: { "status.eq": 1, "&inventory_available.eq": 1 },
  },
  warehouselocation: {
    name: "location/fetch",
    apiFunc: getV1WarehouseLocation,
    dataKey: "warehouseLocationList",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: { "status.eq": 1 },
  },
  uom: {
    name: "uom/fetch",
    apiFunc: getV1Uom,
    dataKey: "units",
    labelKey: "uom_name",
    defaultColumn: ["id", "uom_name", 'is_base_unit', 'conversation_factor'],
    defaultFilter: { "template_id.ne": null },
  },
  discountedItems: {
    name: "discountItems/fetch",
    apiFunc: getV1DiscountItems,
    dataKey: "discountItemsList",
    labelKey: "name",
    defaultColumn: ["id", "name", "discount_rate_amount", "discount_category"],
    defaultFilter: { "status.eq": 1 },
  },
  taxTemplate: {
    name: "taxTemplate/fetch",
    apiFunc: getV1TaxTemplates,
    dataKey: "templates",
    labelKey: "name",
    defaultColumn: ["id", "name", "tax_codes"],
    defaultFilter: null,
  },
  paymentTerm: {
    name: "paymentTerm/fetch",
    apiFunc: getV1PaymentTerms,
    dataKey: "payment_terms_list",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  incoTerms: {
    name: "incoTerms/fetch",
    apiFunc: getV1PurchaseInvoicesIncoterms,
    dataKey: "incoterm",
    labelKey: "term",
    defaultColumn: ["id", "term"],
    defaultFilter: null,
  },
  shippingRules: {
    name: "shippingRules/fetch",
    apiFunc: getV1ShippingRules,
    dataKey: "shippingRules",
    labelKey: "name",
    defaultColumn: ["id", "name", "shipping_cost", "handling_cost"],
    defaultFilter: { 'status.ne': 'Draft' },
  },
  bins: {
    name: "bins/fetch",
    apiFunc: getV1Bin,
    dataKey: "binsList",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  agreement: {
    name: "agreement/fetch",
    apiFunc: getV1PurchaseAgreements,
    dataKey: "purchase_agreements",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  invoices: {
    name: "purchaseInvoices/fetch",
    apiFunc: getV1PurchaseInvoices,
    dataKey: "invoices",
    labelKey: "series_number",
    defaultColumn: ["id", "series_number"],
    defaultFilter: null,
  },
  purchaseOrderReceipts: {
    name: "purchaseGRNs/fetch",
    apiFunc: getV1PurchaseOrdersReceipts,
    dataKey: "grns",
    labelKey: "series_number",
    defaultColumn: ["id", "series_number"],
    defaultFilter: null,
  },
  representatives: {
    name: "representatives/fetch",
    apiFunc: getV1ExpenseReimbursementEmployees,
    dataKey: "employees_list",
    // labelKey: "first_name",
    defaultFilter: { "is_active.eq": 1 },
    defaultColumn: ["id", "first_name", "last_name"],
    labelKey: getPartyName,
  },
  categoryItems: {
    name: "categoryItems/fetch",
    apiFunc: getV1CategoryItems,
    dataKey: "categoryItemsList",
    labelKey: "category_name",
    defaultColumn: ["id", "category_name"],
    defaultFilter: { 'status.eq': 1 },
  },
  customerSegment: {
    name: "customerSegment/fetch",
    apiFunc: getV1CustomerSegment,
    dataKey: "customerSegments",
    labelKey: "name",
    defaultColumn: ["id", "name", "status"],
    defaultFilter: { 'status.ne': 'Draft' },
  },
  accounts: {
    name: "account/fetch",
    apiFunc: getV1ChartOfAccount,
    dataKey: "coa_list",
    labelKey: "account_name",
    defaultColumn: ["id", "account_name", 'currency_id', 'currency_data', 'account_type_id'],
    defaultFilter: { "is_active.eq": 1 },
  },
  account: {
    name: "account/fetch",
    apiFunc: getV1ChartOfAccount,
    dataKey: "coa_list",
    labelKey: "account_name",
    defaultColumn: ["id", "account_name", 'currency_id', 'currency_data', 'account_type_id'],
    defaultFilter: { "is_active.eq": 1 },
  },
  industry: {
    name: "inductry/fetch",
    apiFunc: getV1PartiesIndustry,
    dataKey: "activity_list",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  bom: {
    name: "bom/fetch",
    apiFunc: getV1BillsOfMaterials,
    dataKey: "bom_list",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: { "is_active.eq": 1, "&status.eq": 'Approved' },
  },
  routing: {
    name: "routing/fetch",
    apiFunc: getV1Routing,
    dataKey: "routings",
    labelKey: "route_name",
    defaultColumn: ["id", "route_name"],
    defaultFilter: { "is_active.eq": 1 },
  },
  workCenter: {
    name: "workCenter/fetch",
    apiFunc: getV1WorkCentre,
    dataKey: "workCentres",
    labelKey: "name",
    defaultColumn: ["id", "name"],
  },
  workOrder: {
    name: "workOrder/fetch",
    apiFunc: getV1WorkOrder,
    dataKey: "workOrders",
    labelKey: "series_number",
    defaultColumn: ["id", "series_number"],
    defaultFilter: { "is_active.eq": 1, "&status.ne": "Draft" },
  },
  vehicleNumbers: {
    name: "vehicleNumbers/fetch",
    apiFunc: getV1GateRegisterVehicleNumbers,
    dataKey: "vehicleNumbers",
    labelKey: "number",
    defaultColumn: ["id", "number"],
    defaultFilter: null,
  },
  vehicleTypes: {
    name: "vehicleTypes/fetch",
    apiFunc: getV1GateRegisterVehicleTypes,
    dataKey: "vehicleTypes",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  operations: {
    name: "operations/fetch",
    apiFunc: getV1Operations,
    dataKey: "operations",
    labelKey: "operation_name",
    defaultColumn: ["id", "operation_name"],
    defaultFilter: null,
  },
  assets: {
    name: "assets/fetch",
    apiFunc: getV1Assets,
    dataKey: "assets_list",
    labelKey: "asset_name",
    defaultColumn: ["id", "asset_name"],
    defaultFilter: { 'status.ne': 'cancelled' },
  },
  assetsPo: {
    name: "assets/fetch",
    apiFunc: getV1Assets,
    dataKey: "assets_list",
    labelKey: "asset_name",
    defaultColumn: ["id", "asset_name"],
  },
  equipmentCategories: {
    name: "equipmentCategories/fetch",
    apiFunc: getV1EquipmentsCategories,
    dataKey: "categories",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  equipment: {
    name: "equipment/fetch",
    apiFunc: getV1Equipments,
    dataKey: "equipments",
    labelKey: "name",
    defaultColumn: ["id", "name", "equipment_category_data"],
    defaultFilter: { 'status.ne': 'Draft' },
  },
  workCenterCategories: {
    name: "workCenterCategories/fetch",
    apiFunc: getV1WorkCentreCategories,
    dataKey: "work_centre_categories_list",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  rawMaterials: {
    name: "rawMaterials/fetch",
    apiFunc: getV1BillsOfMaterialsListMaterials,
    dataKey: "materials_list",
    labelKey: "item_data.name",
    defaultColumn: ["id", "item_data"],
    defaultFilter: null,
  },
  countries: {
    name: "countries/fetch",
    apiFunc: getV1LocationsCountries,
    dataKey: "countries",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: { "is_active.eq": 1 },
  },
  rfqs: {
    name: "rfqs/fetch",
    apiFunc: getV1Rfq,
    dataKey: "rfqs",
    labelKey: "series_number",
    defaultColumn: ["id", "series_number"],
    defaultFilter: { 'status.ne': 'Draft' },
  },
  states: {
    name: "states/fetch",
    apiFunc: getV1LocationsStates,
    dataKey: "states",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  assemblyItems: {
    name: "assenmblyItems/fetch",
    apiFunc: getV1AssemblyItems,
    dataKey: "assemblyItemsList",
    labelKey: (item: Record<string, any>) => `${item.sku} - ${item.name}`,
    defaultColumn: [
      "id",
      "name",
      "type",
      "unit_of_measurement",
      "default_tax_id",
      "sales_price",
      "sales_description",
      "total_available_quantity",
      "total_reserved_quantity",
      "purchase_price",
      "purchase_description",
      "cost",
      "is_landed_cost",
      "total_on_hand_quantity",
      'purchase_unit',
      'sales_unit',
      'consumption_unit',
      'stock_unit',
      "sku"
    ],
    defaultFilter: { "status.eq": 1, '&is_variant.eq': 1 },
  },
  journal_type: {
    name: "journal/fetch",
    apiFunc: getV1AssetsJournalTypes,
    dataKey: "journal_types",
    labelKey: "name",
    defaultColumn: ["id", "series_number", "name"],
  },
  journal_entries: {
    name: "journal-entries/fetch",
    apiFunc: getV1JournalEntries,
    dataKey: "journal_entries",
    labelKey: "series_number",
    defaultColumn: ["id", "series_number"],
  },
  reference_types: {
    name: "referenceTypes/fetch",
    apiFunc: getV1JournalEntriesReferenceType,
    dataKey: "reference_types",
    labelKey: "name",
    defaultColumn: ["id", "name"],
  },
  invoice: {
    name: "invoice/fetch",
    apiFunc: getV1SalesInvoices,
    dataKey: "invoices",
    labelKey: "series_number",
    defaultColumn: ["id", "series_number"],
  },
  bills: {
    name: "bills/fetch",
    apiFunc: getV1PurchaseInvoices,
    dataKey: "invoices",
    labelKey: "series_number",
    defaultColumn: ["id", "series_number"],
  },
  notesReasons: {
    name: "notesReasons/fetch",
    apiFunc: getV1DebitNotesReasons,
    dataKey: "reasons",
    labelKey: "reason_name",
    defaultColumn: ["id", "reason_name"],
  },
  expenseCategories: {
    name: "expenseCategories/fetch",
    apiFunc: getV1ExpenseReimbursementExpenseCategories,
    dataKey: "expense_category_list",
    labelKey: "name",
    defaultColumn: ["id", "name"],
  },
  commissionTarget: {
    name: "commissionTargets/fetch",
    apiFunc: getV1CommissionTargets,
    dataKey: "commission_targets",
    labelKey: "series_number",
    defaultColumn: ["id", "series_number"],
    defaultFilter: { "is_draft.eq": 0 },
  },
  commissionPlan: {
    name: "commissionPlans/fetch",
    apiFunc: getV1CommissionPlans,
    dataKey: "commission_plans",
    labelKey: "title",
    defaultColumn: ["id", "title", 'type'],
    defaultFilter: { "status.eq": 1 },
  },
  assetTypes: {
    name: "assetTypes/fetch",
    apiFunc: getV1AssetsAssetTypes,
    dataKey: "asset_types",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  fiscalYear: {
    name: "fiscalYear/fetch",
    apiFunc: getV1FiscalYear,
    dataKey: "fiscal",
    labelKey: "year_name",
    defaultColumn: ["id", "year_name", 'year_start_date', 'year_end_date'],
    defaultFilter: null,
  },
  budgetMonth: {
    name: "budgetMonth/fetch",
    apiFunc: getV1BudgetBudgetMonths,
    dataKey: "budget_months",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  budgetType: {
    name: "budgetType/fetch",
    apiFunc: getV1BudgetBudgetTypes,
    dataKey: "budget_types",
    labelKey: "name",
    defaultColumn: ["id", "name"],
    defaultFilter: null,
  },
  account_types: {
    name: "accountTypes/fetch",
    apiFunc: getV1ChartOfAccountAccountType,
    dataKey: "activity_list",
    labelKey: "type_name",
    defaultColumn: ["id", "type_name"],
  },
  taxCategories: {
    name: "taxCategories/fetch",
    apiFunc: getV1TaxCategory,
    dataKey: 'tax_category_list',
    labelKey: "name",
    defaultColumn: ['id', 'name']
  },
  taxCodes: {
    name: 'taxCodes/fetch',
    apiFunc: getV1TaxCode,
    dataKey: 'tax_code',
    labelKey: "name",
    defaultColumn: ['id', 'name']
  },
  bankAccountType: {
    name: 'bankAccountType/fetch',
    apiFunc: getV1BankAccountsTypes,
    dataKey: 'account_types',
    labelKey: "name",
    defaultColumn: ['id', 'name']
  },
  bank: {
    name: 'bank/fetch',
    apiFunc: getV1Banks,
    dataKey: 'banks_list',
    labelKey: "name",
    defaultColumn: ['id', 'name']
  },
  dueDateType: {
    name: 'dueDateType/fetch',
    apiFunc: getV1PaymentTermsDueDateTypes,
    dataKey: 'due_date_list',
    labelKey: "value",
    defaultColumn: ['id', 'value']
  },
  brand: {
    name: 'brand/fetch',
    apiFunc: getV1Brand,
    dataKey: '',
    labelKey: "name",
    defaultColumn: ['id', 'name']
  },
  stockReason: {
    name: 'stockReason/fetch',
    apiFunc: getV1StockReason,
    dataKey: '',
    labelKey: "name",
    defaultColumn: ['id', 'name']
  },
  contacts: {
    name: 'contacts/fetch',
    apiFunc: getV1OpportunityContact,
    dataKey: '',
    labelKey: "name",
    defaultColumn: ['id', 'name']
  },
  rnTermsConditions: {
    name: 'rnTermsConditions/fetch',
    apiFunc: getV1RentalTermsConditions,
    dataKey: 'terms_and_conditions',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
    defaultFilter: { 'is_active.eq': 1 },
  },
  rnAgreements: {
    name: 'rnAgreements/fetch',
    apiFunc: getV1RentalAgreements,
    dataKey: 'purchase_agreements',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
    defaultFilter: { 'status.eq': "'In Progress'", '&is_rental.eq': 1 },
  },
  rnBillingCycle: {
    name: 'rnTermsConditions/fetch',
    apiFunc: getV1RentalBillingCycles,
    dataKey: 'billing_cycles',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
    defaultFilter: null,
  },
  // priceList:{
  //   name:'priceList/fetch',
  //   apiFunc: getV1PriceLis,
  //   dataKey:'',
  //   labelKey: "name",
  //   defaultColumn:['id','name']
  // },
  rnChOrders: {
    name: 'rnChOrders/fetch',
    apiFunc: getV1CrossHireOrders,
    dataKey: 'purchase_orders',
    labelKey: "series_number",
    defaultColumn: ['id', 'series_number'],
    defaultFilter: { '&is_rental.eq': 1 },
  },
  languages: {
    name: 'languages/fetch',
    apiFunc: getV1Languages,
    dataKey: 'languages',
    labelKey: "name",
    defaultColumn: ['id', 'name', 'code'],
  },
  roles: {
    name: 'roles/fetch',
    apiFunc: getV1Role,
    dataKey: 'roles',
    labelKey: "name",
    defaultColumn: ['id', 'name', 'code'],
  },
  reports: {
    name: 'reports/fetch',
    apiFunc: getV1ReportsReportList,
    dataKey: 'reports',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
  },
  uom_templates: {
    name: 'uomTemplate/fetch',
    apiFunc: getV1UomTemplates,
    dataKey: 'templates',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
    defaultFilter: { "is_active.eq": 1 },
  },
  templates: {
    name: 'templates/fetch',
    apiFunc: getV1Templates,
    labelKey: "subject_id",
    valueKey: "_id",
    defaultColumn: ['_id', 'subject_id', 'name'],
  },
  workflow_reference: {
    name: 'workflow_reference/fetch',
    apiFunc: getV1WorkflowReferences,
    dataKey: 'workflow_reference',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
  },
  grades: {
    name: 'grades/fetch',
    apiFunc: getV1Grades,
    dataKey: 'grades',
    labelKey: "grade_name",
    defaultColumn: ['id', 'grade_name'],
  },
  useModules: {
    name: 'useModules/fetch',
    apiFunc: getV1UserModules,
    dataKey: 'modules',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
  },

  // HRMS
  timezone: {
    name: 'timezone/fetch',
    apiFunc: getV1Timezones,
    dataKey: 'timezones',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
  },
  designation: {
    name: 'designation/fetch',
    apiFunc: getV1Designation,
    dataKey: 'designations',
    labelKey: "name",
    defaultFilter: { 'status.eq': 1 },
    defaultColumn: ['id', 'name', 'department_id'],
  },
  team: {
    name: 'team/fetch',
    apiFunc: getV1Teams,
    dataKey: 'teams',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
  },
  accural_type: {
    name: 'accural_type/fetch',
    apiFunc: getV1AccrualType,
    dataKey: 'accural_types',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
  },
  accrual_master: {
    name: 'accrual_master/fetch',
    apiFunc: getV1AccrualMaster,
    dataKey: 'accrual_master',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
  },
  leave_category: {
    name: 'leave_category/fetch',
    apiFunc: getV1LeaveCategory,
    dataKey: 'leave_categories',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
  },
  // Leave Policy Master - Manages leave policies and configurations for employees
  leave_policy_master: {
    name: 'leave_policy_master/fetch',
    apiFunc: getV1LeavePolicyMaster,
    dataKey: 'leave_policy_masters',
    labelKey: "leave_type_title",
    defaultColumn: ['id', 'leave_type_title'],
    defaultFilter: { "status.eq": 1, '&is_draft.eq': 0, '&leave_category_id.isnull': false },
  },
  loan_master: {
    name: 'loan_master/fetch',
    apiFunc: getV1LoanMaster,
    dataKey: 'loan_master',
    labelKey: "loan_name",
    defaultColumn: ['id', 'loan_name'],
  },
  // Document Master - Manages document types and templates for HR processes
  document_master: {
    name: 'document_master/fetch',
    apiFunc: getV1DocumentMaster,
    dataKey: 'document_master',
    labelKey: "document_type_name",
    defaultColumn: ['id', 'document_type_name'],
    defaultFilter: { "status.eq": 1 },
  },
  // Company Calendar - Manages company-wide calendar events, holidays, and schedules
  company_calendar: {
    name: 'company_calendar/fetch',
    apiFunc: getV1CompanyCalendar,
    dataKey: 'company_calendars',
    labelKey: "calendar_name",
    defaultColumn: ['id', 'calendar_name'],
  },
  // Employee Contracts - Manages employment contracts and agreements
  employee_contract: {
    name: 'employee_contract/fetch',
    apiFunc: getV1EmployeeContracts,
    dataKey: 'employee_contracts',
    labelKey: "contract_name",
    defaultColumn: ['id', 'contract_name'],
  },
  // Employee Management - Core employee data and information management
  employees: {
    name: 'employees/fetch',
    apiFunc: getV1Employee,
    dataKey: 'employees',
    labelKey: "name",
    defaultColumn: ['id', 'name', 'account'],
    customFilter: { 'status.ne': 'Draft' },
  },
  // Salary Structures - Manages Salary Structures
  salary_structures: {
    name: 'salary_structures/fetch',
    apiFunc: getV1SalaryStructureMaster,
    dataKey: 'salary_structure_master',
    labelKey: "structure_name",
    defaultColumn: ['id', 'structure_name', 'min_salary', 'max_salary'],
    defaultFilter: { "is_active.eq": 1, '&is_draft.eq': 0 },
  },

  skills: {
    name: 'skills/fetch',
    apiFunc: getV1Skills,
    dataKey: 'skills',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
  },

  hire_requests: {
    name: 'hire_requests/fetch',
    apiFunc: getV1HireRequests,
    dataKey: 'hire_requests',
    labelKey: "series_number",
    defaultColumn: ['id', 'series_number', 'designation_id', 'designation_data'],
    defaultFilter: { "status.eq": 'Accepted' },
  },

  job_posts: {
    name: 'job_posts/fetch',
    apiFunc: getV1JobPosts,
    dataKey: 'job_posts',
    labelKey: "title",
    defaultColumn: ['id', 'title'],
  },

  budgets_list: {
    name: 'budgets_list/fetch',
    apiFunc: getV1Budget,
    dataKey: 'budgets_list',
    labelKey: "budget_name",
    defaultColumn: ['id', 'budget_name'],
    defaultFilter: { "status.eq": 'Approved' },
  },
  employee_assets: {
    name: 'employee_assets/fetch',
    apiFunc: getV1MyAssets,
    dataKey: 'assets',
    labelKey: "asset_name",
    defaultColumn: ['id', 'asset_name'],
  },

  // PMS
  projects: {
    name: 'projects/fetch',
    apiFunc: getV1Projects,
    dataKey: 'projects',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
    defaultFilter: { "status.eq": 'Active' },
  },
  tasks: {
    name: 'tasks/fetch',
    apiFunc: getV1Tasks,
    dataKey: 'tasks',
    labelKey: "name",
    defaultColumn: ['id', 'name', 'project_id'],
    defaultFilter: null,
  },
  cost_codes: {
    name: 'cost_codes/fetch',
    apiFunc: getV1CostCodes,
    dataKey: 'cost_codes',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
    defaultFilter: { "is_active.eq": 1 },
  },
  cost_elements: {
    name: 'cost_elements/fetch',
    apiFunc: getV1CostElements,
    dataKey: 'cost_elements',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
    defaultFilter: { "is_active.eq": 1 },
  },
  salesOrder: {
    name: 'sales_order/fetch',
    apiFunc: getV1SalesOrders,
    dataKey: 'sales_orders',
    labelKey: "series_number",
    defaultColumn: ['id', 'series_number'],
    defaultFilter: { "status.ne": 'Draft' },
  },
  sourceType: {
    name: 'source-types/fetch',
    apiFunc: getV1SourceTypes,
    dataKey: 'source_types_list',
    labelKey: "name",
    defaultColumn: ['id', 'name'],
    defaultFilter: { "status.eq": 1 },
  },
};

export type ApiConfigurationEntry = {
  name: string;
  apiFunc: (params: any) => Promise<any>;
  dataKey: string;
  labelKey: string | ((item: Record<string, any>) => string);
  defaultColumn: string[];
  defaultFilter?: Record<string, any> | string | null;
  valueKey?: string;
};

/**
 * Extend apiConfigurations with additional entries from consuming apps.
 * Call this before any fetchApi usage (e.g., inside ERPUIProvider initialization).
 */
export function extendApiConfigurations(
  entries: Record<string, ApiConfigurationEntry>
): void {
  Object.assign(apiConfigurations, entries);
}

export const fetchApi = async ({
  apiKey,
  filters,
  labelKey,
  valueKey
}: {
  apiKey: keyof typeof apiConfigurations | string;
  filters: any;
  labelKey?: string;
  valueKey?: string;
}) => {
  try {
    const config = apiConfigurations[apiKey];
    if (!config) {
      throw `API configuration for key "${apiKey}" not found.`;
    }
    const res = await getOptions(
      config.apiFunc,
      filters,
      config.dataKey,
      labelKey || config.labelKey,
      config.defaultColumn,
      config.defaultFilter,
      valueKey
    );
    return res;
  } catch (error: any) {
    const newError = new Error(error);
    showSnackBar(newError);
    throw newError;
  }
};
export const getCurrency = () => { };

export const getItems = () => { };
